<template>
  <div>
    <section class="content">
      <div class="row" v-if="answer">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-body">
              <table class="table table-striped" style="font-size:16px" >        
                <tbody>
                  <tr>
                    <th width="13%">Descripción:</th>
                    <td style="padding-right:30px">{{answer.description}}</td>
                  </tr>
                  <tr>
                    <th>Fecha y hora:</th>
                    <td>{{answer.dateComments}}</td>
                  </tr>
                  <!-- <tr>
                    <th>Estado:</th>
                    <td v-if="answer.statusComments === '1'">Enviado</td>
                    <td v-else-if="answer.statusComments === '2'">Entregado</td>
                    <td v-else-if="answer.statusComments === '3'">Visto</td>
                  </tr>-->
                  <tr v-if="answer.idRefenceTo">
                    <th>En respuesta a:</th>
                    <td><span v-for="(item,index) in comments"><font v-if="item.idComments === answer.idRefenceTo">{{ item.description }}</font></span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
              <div class="col-md-12 text-center" v-if="!answer" >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="info-box ">
                      <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                      <div class="info-box-content">
                        <span class="info-box-text">Advertencia</span>
                        <span class="info-box-info">Comentario no encontrado</span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  <!-- /.info-box -->
                </div>
              </div>
              <router-link to="/allComments" tag="button" v-bind:class="'btn btn-primary btn-lg'">Ver todos los mensajes</router-link>
        
    </section>
  </div>
</template>

<script>
  require('moment')
  import datepicker from 'vue-date-picker'
  import api from '../../api'

  export default {
    name: 'Settings',
    components: {
      datepicker
    },
    data (router) {
      return {
        section: 'CommentDetail',
        loading: '',
        answers: this.$store.state.answers,
        answersNew: this.$store.state.answersNew,
        comments: this.$store.state.comments,
        answer: '',
        idUser: this.$store.state.user.idUser,
        c: this.$route.query.c
      }
    },
    computed: {
      datetime () {
        return new Date()
      }
    },
    methods: {
      checkComments () {
        const {idUser} = this

        // We need to pass the component's this context
        // to properly make use of http in the auth service
        api.request('GET', 'api/getComments?idUser=' + idUser)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.answers) {
            this.answersNew = []
            this.answers = data.answers
            this.$store.commit('SET_ANSWERS', data.answers)
            for (var j = 0; j < this.answers.length; j++) {
              if (this.answers[j].statusComments === '2') {
                this.answersNew.push(this.answers[j])
              }
            }
            if (this.answersNew.length >= 0) {
              this.$store.commit('SET_ANSWERSNEW', this.answersNew)
              this.answersNew = this.$store.state.answersNew
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      }
    },
    beforeMount () {
      this.answers = this.$store.state.answers
      for (var j = 0; j < this.answers.length; j++) {
        if (this.answers[j].idComments === this.c) {
          this.answer = this.answers[j]
        }
      }
      api.request('get', 'api/readComment?idComments=' + this.answer.idComments)
        .then(response => {
          this.checkComments()
        })
        .catch(error => {
          console.log(error)
        })
      // this.$store.commit('SET_ANSWERSNEW', this.answersNew) // SEGUIR ACA FALTA HACER LA API PARA MARCAR LEIDO Y LISTO
    },
    filters: {
      truncate: function (string, value) {
        return string.substring(0, value) + '...'
      }
    }
}
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }


</style>



// WEBPACK FOOTER //
// CommentDetail.vue?5d970246